define([
  /* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min',
  'readingiq-src/js/riq-js/access-control-service/1.0.0/index',
  'readingiq-src/js/riq-js/riq-analytics-service/1.0.1/index'
  /* eslint-enable */
], function marketingPopupListenerModule(app, aoflModules) {
  'use strict';
  /* eslint-disable no-unused-vars */
  var storeService = aoflModules.store;

  app.registerComponent('marketingPopupListener', {
    require: {},
    bindings: {},
    controller: 'marketingPopupListenerController'
  });
  app.registerController('marketingPopupListenerController', [
    '$rootScope',
    'accessControlService',

    'riqAnalyticsService',
    function controller($rootScope, accessControlService, riqAnalyticsService) {
      var blacklist = {
        edit_profile_en: true,
        change_billing_en: true,
        book_intercept_en: true,
        categories_details_en: true,
        manage_subscription_en: true
      };

      $rootScope.$on('$stateChangeStart', function onStateChangeStart(
        event,
        toState,
        toStateParams,
        fromState,
        fromStateParams
      ) {
        var state = storeService.getState();
        var userRole = state.user ? state.user.role : '';

        if (
          userRole &&
          accessControlService.can('view_marketing_modal') &&
          blacklist[toState.name]
        ) {
          // TODO: remove the hardcoded collection ids
          var isTeacherShelf =
            toState.name === 'categories_details_en' &&
            (toStateParams.id === '63' || toStateParams.id === '88');
          var isNotAddChild =
            toState.name === 'edit_profile_en' && toStateParams.state !== 'add';
          if (isTeacherShelf || isNotAddChild) {
            return;
          }
          event.preventDefault();
          storeService.commit([
            {
              stateAlias: 'riqModals',
              mutationId: 'show',
              payload: 'marketingModal'
            }
          ]);
          riqAnalyticsService.enqueueEvent({
            event_type: 'AOFL.READINGIQ_PRIVATE.V1.MarketingPrompt',
            payload: {
              activity_cid: toStateParams.id,
              collection_Id: toStateParams.collectionId
            }
          });
        }
      });
    }
  ]);
});
